/* eslint-disable parog-web/no-glint-expect-error-directive */
import { get } from '@ember/helper';
import { service } from '@ember/service';
import { dasherize } from '@ember/string';
import eq from 'ember-truth-helpers/helpers/eq';
import Divider from 'ember-wiser/components/divider';
import CrudJournalEventBaseComponent from 'parog-web/components/forc/abstract/crud-journal-event-based-component';
import type { ForcModelPojo } from 'parog-web/components/forc/abstract/journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import journalEventRetrievalStrategies from 'parog-web/components/forc/utils/journal-event-retrieval-strategies';
import IbdDiskSurveyFilledJournalEvent from 'parog-web/models/ibd-disk-survey-filled-journal-event';
import type SemeiaSessionService from 'parog-web/services/session';
import Sections from './base-consult-form/sections';

export default class MiciIbdDiskSurveyConsultFormDetails extends CrudJournalEventBaseComponent<IbdDiskSurveyFilledJournalEvent> {
  static override fullComponentId = 'mici/ibd-disk-survey-consult-form-details';
  static override journalEventClass = IbdDiskSurveyFilledJournalEvent;

  @service declare session: SemeiaSessionService;

  override retrieveJournalEvent =
    journalEventRetrievalStrategies.sourceJournalEvent;
  Sections = Sections;

  override get forcDisplayName(): string {
    return this.session.medic ? 'Questionnaire IBD-Disk' : 'Qualité de vie';
  }

  get sections(): Array<string> {
    return IbdDiskSurveyFilledJournalEvent.sections;
  }

  override retrieveModel(): ForcModelPojo {
    const model = super.retrieveModel();

    this.sections.forEach(section => {
      if (!model[section]) {
        model[section] = '0';
      }
    });

    return model;
  }

  <template>
    <Provider @forcComponent={{this}}>
      <:content as |form|>
        <div class='field'>
          <form.Date
            @labelName='Date du questionnaire'
            @propertyName='occurredAt'
          />
        </div>
        <div class='ui info message visible' data-test-ibd-disk-info>

          <b>Au cours des deux dernières semaines, à quelle fréquence
            {{#if this.session.medic}}le patient a{{else}}vous avez{{/if}}
            été dérangé par les problèmes suivants :</b>
          <br />
          (Veuillez déplacer la réglette au niveau souhaité :
          <ul>
            <li>
              0 correspondant à "Je ne suis pas du tout d’accord"
            </li>
            <li>
              5 à "Ni d’accord ni pas d’accord"
            </li>
            <li>
              10 à "Je suis tout à fait d’accord")
            </li>
          </ul>
        </div>
        <div class='flex flex-col gap-8'>
          {{#each this.sections as |section index|}}
            {{#unless (eq index 0)}}
              <Divider />
            {{/unless}}
            {{#let (get this.Sections (dasherize section)) as |Section|}}
              {{! @glint-expect-error }}
              <Section @form={{form}} @forcComponent={{@forcComponent}} />
            {{/let}}
          {{/each}}
        </div>
      </:content>
    </Provider>
  </template>
}
